<template>
  <a-layout style="height: 100vh">
    <a-layout-sider v-model:collapsed="collapsed" collapsible :trigger="null">
      <h-menu />
      <div class="version">版本：{{ version }}</div>
    </a-layout-sider>
    <a-layout>
      <a-layout-content style="margin: 0 16px">
        <div class="router-body">
          <div class="router-header">
            <h-header @collapsed="onCollapsed" />
          </div>
          <div class="router-content" ref="consoleContentRef">
            <router-view></router-view>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script lang="ts" setup>
import defaultConfig from '@/configs/default.config'
import { nextTick, onMounted, ref } from 'vue'
import HMenu from '@/components/layout/SiderMenu.vue'
import HHeader from '@/components/layout/ConsoleHeader.vue'
import { useAppStore, useDataStore, useUserStore } from '@/store'

const appStore = useAppStore()
const dataStore = useDataStore()
const userStore = useUserStore()
const { version } = defaultConfig
const collapsed = ref(false)
const consoleContentRef = ref()

const onCollapsed = (e: boolean) => {
  collapsed.value = e
}

const getGradeList = async () => {
  const list = await dataStore.getGradeList({ Limit: 9999, Offset: 0 })
  const vlist = list.map(x => {
    return {
      label: x.name,
      value: x.id
    }
  })

  dataStore.$patch({
    gradeOptions: vlist
  })
}

const getSchoolList = async () => {
  const list = await dataStore.getSchoolList({ Limit: 9999, Offset: 0 })
  const vlist = list.map(x => {
    return {
      label: x.name,
      value: x.id
    }
  })

  dataStore.$patch({
    schoolOptions: vlist
  })
}

document.documentElement.style.fontSize = document.documentElement.clientWidth / 19.2 + 'px'

onMounted(() => {
  nextTick(() => {
    appStore.setDeviceContentHeight(consoleContentRef.value.offsetHeight - 10)
    appStore.setDeviceContentWidth(consoleContentRef.value.offsetWidth)

    dataStore.getAllRoleList().then()

    if (userStore.userInfo?.schoolId) {
      getGradeList()
    }

    if (userStore.userInfo?.roleIds.includes(2)) {
      getSchoolList()
    }

  })
})

</script>

<style lang="less" scoped>
.router-body {
  height: 100%;
  width: 100%;
  padding: 68px 0 0;
  box-sizing: border-box;
  position: relative;
}

.router-header {
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: 0 0 5px rgba(100, 100, 100, 0.1);
  position: absolute;
  top: 9px;
  left: 0;
  border-radius: 5px;
}

.router-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.version {
  position: relative;
  top: -20px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  color: #f1f1f1;
}
</style>